import { Brand, Offer } from "@prisma/client";
import { useFeatureFlag } from "components/useFeatureFlag";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

export const useClientSideInfo = (
  initialBrandId: Brand["id"],
  offers: Array<Offer>
) => {
  const [cookies, setCookies] = useState<string>("");
  const [userAgent, setUserAgent] = useState<string>("");
  const [transactionUrl, setTransactionUrl] = useState<string>("");
  const [clientSideId] = useState<string>(uuidv4());
  const [brandId] = useState<string>(initialBrandId);

  const handleMessage = ({ data }: any) => {
    try {
      if (data.type === "cc-analytics-data") {
        const payload = JSON.parse(data.payload);
        setCookies(payload.cookies);
        setUserAgent(payload.userAgent);
        setTransactionUrl(payload.transactionUrl);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage, false);

    return () => {
      window.removeEventListener("message", handleMessage, false);
    };
  }, []);

  return {
    cookies,
    userAgent,
    transactionUrl,
    clientSideId,
    brandId,
    offers,
  } as const;
};
